import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import { storePasien } from "@/store/modules/pasien";
import CommonFormulir, { EnFormulirCategory } from "@/services/CommonFormulir";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";

@Component({
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class BaseFormulir extends Vue {
  register: string | number;
  pageIsReadOnly!: () => boolean;

  expandInput = false;
  pageTab = "tab-soap";
  // allowedUnit = ["05", "2C"];
  allowedUnit = [];
  modalTtd = false;

  formStore;

  formSvc: CommonFormulir;

  formUrl =
    process.env.VUE_APP_API_URL +
    `/formulir/${EnFormulirCategory.KlaimRehabMedis}`;

  getPdfUrl(category: string, id: number) {
    return process.env.VUE_APP_API_URL + `/formulir/${category}/${id}/pdf`;
  }

  get dataForm() {
    return this.formStore.formulir;
  }

  get tglSurat() {
    return moment(this.dataForm?.surat_date).format("DD-MM-YYYY");
  }

  get loadContent(): boolean {
    return this.formStore.loading;
  }

  get creatorUserId() {
    return this.dataForm?.creator_user_id;
  }

  get signeeUserId() {
    return this.dataForm?.signee_user_id;
  }

  get isReadOnly() {
    if (this.pageIsReadOnly()) return true;
    return (
      !this.allowedUnit.includes(userModule.user.unit_id) &&
      !this.allowedUnit.includes("*")
    );
  }

  // get isReadOnly() {
  //   return false;
  // }

  get pasien() {
    return storePasien.identitasPasien;
  }

  backPageSoap() {
    this.$emit("pageTab", this.pageTab);
  }

  print(id) {
    this.formSvc.print(id);
  }

  showInput() {
    this.expandInput = true;
  }

  closeInput() {
    this.expandInput = false;
  }

  showSignatureModal() {
    this.modalTtd = true;
  }

  passTtd(value) {
    appModule.setLoading(true);

    this.formSvc
      .sign(this.dataForm.id, { password: value })
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay("Berhasil Tanda Tangan Surat Keterangan");
          appModule.addMsgTtd("");
          this.formStore.getByRegister(this.register);
        } else {
          appModule.sendErrorAlert(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);
        this.modalTtd = false;
      });
  }

  remove() {
    appModule.setLoading(true);

    this.formSvc
      .destroy(this.dataForm?.id)
      .then(dt => {
        if (dt.status == 1) {
          appModule.NoticeDelay(dt.message);
        }
      })
      .finally(() => {
        appModule.setLoading(false);

        this.formStore.getByRegister(this.register);
      });
  }
}
